export const SET_IS_OPEN_AGE_VERIFICATION_PROCESS_MODAL = 'age-verification/SET_IS_OPEN_AGE_VERIFICATION_PROCESS_MODAL'
export const SET_IS_OPEN_AGE_VERIFIED_MODAL = 'age-verification/SET_IS_OPEN_AGE_VERIFIED_MODAL'
